import styled from "styled-components"

const StyledSection = styled.div``

const Title = styled.div`
  font-size: 3.25rem;
  font-weight: bold;
`

const Body = styled.div``

const Section = ({title, body}) => {
  return (
    <StyledSection>
      <Title>
        {title}
      </Title>
      <Body>
        {body}
      </Body>
    </StyledSection>
  )
}

export default Section